import { PageTitle } from '_metronic/layout/core'

import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import Select from 'react-select'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import GalleryImageForm from './Components/GalleryImageForm'
import Lightbox from 'yet-another-react-lightbox'

import useViewModel from './ViewModel'
import clsx from 'clsx'
import { TABS } from '../Config'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import { KTSVG } from '_metronic/helpers'

const ImagesView: React.FC = () => {
	const {
		companyName,
		currentTab,
		onChangeTab,
		formState,
		onChange,
		onSubmit,
		isSubmitting,
		isSubmittingGalleryImageForm,
		openGalleryImageForm,
		galleryImage,
		onOpenGalleryImageForm,
		onCloseGalleryImageForm,
		onChangeGalleryImage,
		onSubmitGalleryImageForm,
		onRemoveGalleryImage,
		galleryImageIndex,
		openLightBoxGallery,
		onOpenLightBoxGallery,
		onCloseLightBoxGallery,
	} = useViewModel()

	return (
		<ViewPageTitle companyName={companyName}>
			<Lightbox
				index={galleryImageIndex}
				open={openLightBoxGallery}
				close={onCloseLightBoxGallery}
				slides={(formState?.galleryImages ?? []).map((p: any, idx: number) => ({
					src: p.path,
					caption: `Gallery Image ${idx + 1}`,
				}))}
				styles={{ container: { backgroundColor: 'rgba(0, 0, 0, .6)' } }}
			/>

			<GalleryImageForm
				open={openGalleryImageForm}
				image={galleryImage}
				isSubmitting={isSubmittingGalleryImageForm}
				onChange={onChangeGalleryImage}
				onClose={onCloseGalleryImageForm}
				onConfirm={onSubmitGalleryImageForm}
			/>

			<div className="row gy-5">
				<div className="col-12 d-none d-xl-block">
					<TabsButtonGroup
						manualActiveTab={currentTab}
						changeTab={onChangeTab}
						tabNames={TABS.map(tab => tab.tabName)}
						tabContents={[<></>]}
					/>
				</div>

				<div className="col-12 d-xl-none">
					<Select
						isSearchable={false}
						options={TABS.map((tab, idx) => ({ value: idx, label: tab.tabName }))}
						value={{ label: TABS.find((_, idx) => idx === currentTab)?.tabName }}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
							}),
							menu: (baseStyles, state) => ({
								...baseStyles,
								zIndex: 9999,
							}),
						}}
						onChange={(selected: any) => {
							if (selected !== null) onChangeTab(Number(selected?.value))
						}}
					/>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-0 mt-4">
							<div className="card-title">
								{/* Title */}
								<div>
									<h4 className="text-kumopack-grey-900 fw-bold mb-2">Images</h4>
									<div className="text-kumopack-grey-600 fs-6">
										Please specify page description here
									</div>
								</div>
							</div>
							<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
						</div>

						<div className="card-body">
							{/* begin: Card */}
							<div className="row mt-10 mb-5">
								<label className="form-label col-12 col-xl-3 mb-5 mb-xl-0 d-flex flex-column">
									<div className="fw-bold">Card</div>
									<div className="text-kumopack-grey-600 fs-8">(Recommended 800x400px)</div>
								</label>
								<div className="col-12 col-xl-9 mb-0">
									<div
										className="w-100 rounded bg-kumopack-base-white border mb-5 text-center shadow d-flex align-items-center justify-content-center position-relative"
										style={{ height: '320px' }}>
										{formState.companyCard && (
											<div
												className="btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute"
												style={{ top: -10, right: -10 }}
												onClick={() => onChange('companyCard', null)}>
												<KTSVG
													className="svg-icon-1"
													path="/media/icons/duotune/general/gen027.svg"
												/>
											</div>
										)}
										{formState.companyCard && (
											<img
												className="mx-auto h-100 w-100 rounded"
												src={
													typeof formState.companyCard !== 'string'
														? URL.createObjectURL(formState.companyCard as any)
														: formState.companyCard
												}
												onError={(e: any) => {
													e.target.onerror = null
													e.target.src = '/media/icons/kumopack/default-placeholder.png'
												}}
												alt="Factory Cover"
												style={{ userSelect: 'none', pointerEvents: 'none', objectFit: 'contain' }}
											/>
										)}
										{!formState.companyCard && (
											<div className="fw-bold fs-5 text-kumopack-grey-300 py-10">
												No Files Uploaded
											</div>
										)}
									</div>
									<FormGenerator
										formKey="supplier-add-form-drag-and-drop-company-card-photo"
										inputType="drag-and-drop"
										multiple={false}
										accept="image/*"
										onFileUpload={coverFiles => onChange('companyCard', coverFiles[0])}
									/>
								</div>
							</div>

							{/* begin:: Cover photo */}
							<div className="row mb-5">
								<label className="form-label col-12 col-xl-3 mb-5 mb-xl-0 d-flex flex-column">
									<div className="fw-bold">Cover Photo</div>
									<div className="text-kumopack-grey-600 fs-8">(Recommended 800x400px)</div>
								</label>
								<div className="col-12 col-xl-9 mb-0">
									<div
										className="w-100 rounded bg-kumopack-base-white border mb-5 text-center shadow d-flex align-items-center justify-content-center position-relative"
										style={{ height: '320px' }}>
										{formState.companyPictureCover && (
											<div
												className="btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute"
												style={{ top: -10, right: -10 }}
												onClick={() => onChange('companyPictureCover', null)}>
												<KTSVG
													className="svg-icon-1"
													path="/media/icons/duotune/general/gen027.svg"
												/>
											</div>
										)}
										{formState.companyPictureCover && (
											<img
												className="mx-auto h-100 w-100 rounded"
												src={
													typeof formState.companyPictureCover !== 'string'
														? URL.createObjectURL(formState.companyPictureCover as any)
														: formState.companyPictureCover
												}
												onError={(e: any) => {
													e.target.onerror = null
													e.target.src = '/media/icons/kumopack/default-placeholder.png'
												}}
												style={{ userSelect: 'none', pointerEvents: 'none', objectFit: 'contain' }}
												alt="Factory Cover"
											/>
										)}
										{!formState.companyPictureCover && (
											<div className="fw-bold fs-5 text-kumopack-grey-300 py-10">
												No Files Uploaded
											</div>
										)}
									</div>
									<FormGenerator
										formKey="supplier-add-form-drag-and-drop-factory-photo"
										inputType="drag-and-drop"
										multiple={false}
										accept="image/*"
										onFileUpload={coverFiles => onChange('companyPictureCover', coverFiles[0])}
									/>
								</div>
							</div>
							{/* end:: Cover photo */}

							{/* begin:: Factory Cover */}
							<div className="row mb-5">
								<label className="form-label col-12 col-xl-3 mb-5 mb-xl-0 d-flex flex-column">
									<div className="fw-bold">รูปภาพโรงงาน</div>
									<div className="text-kumopack-grey-600 fs-8">(Recommended 800x400px)</div>
								</label>
								<div className="col-12 col-xl-9 mb-0">
									<div
										className="w-100 rounded bg-kumopack-base-white border mb-5 text-center shadow d-flex align-items-center justify-content-center position-relative"
										style={{ height: '320px' }}>
										{formState.companyFactoryPicture && (
											<div
												className="btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute"
												style={{ top: -10, right: -10 }}
												onClick={() => onChange('companyFactoryPicture', null)}>
												<KTSVG
													className="svg-icon-1"
													path="/media/icons/duotune/general/gen027.svg"
												/>
											</div>
										)}
										{formState.companyFactoryPicture && (
											<img
												className="mx-auto w-100 h-100 rounded"
												src={
													typeof formState.companyFactoryPicture !== 'string'
														? URL.createObjectURL(formState.companyFactoryPicture as any)
														: formState.companyFactoryPicture
												}
												onError={(e: any) => {
													e.target.onerror = null
													e.target.src = '/media/icons/kumopack/default-placeholder.png'
												}}
												style={{ userSelect: 'none', pointerEvents: 'none', objectFit: 'contain' }}
												alt="Factory Cover"
											/>
										)}
										{!formState.companyFactoryPicture && (
											<div className="fw-bold fs-5 text-kumopack-grey-300 py-10">
												No Files Uploaded
											</div>
										)}
									</div>
									<FormGenerator
										formKey="supplier-add-form-drag-and-drop-cover-photo"
										inputType="drag-and-drop"
										multiple={false}
										accept="image/*"
										onFileUpload={coverFiles => {
											onChange('companyFactoryPicture', coverFiles[0])
										}}
									/>
								</div>
							</div>

							{/* begin: Profile Gallery */}
							<div className="row mb-5">
								<label className="form-label col-12 col-xl-3 mb-5 mb-xl-0 d-flex flex-column">
									<div className="fw-bold">Gallery</div>
									<div className="text-kumopack-grey-600 fs-8">
										รูปภาพจะถูกนำไปแสดง บนหน้าโปรไฟล์ของท่าน
									</div>
								</label>
								<div className="col-12 col-xl-9 mb-0">
									<button
										type="button"
										className="btn btn-sm btn-kumopack-primary-700 text-kumopack-base-white"
										onClick={onOpenGalleryImageForm}>
										เพิ่มรูปภาพ
									</button>

									{formState.galleryImages && formState.galleryImages.length > 0 ? (
										<div className="row mt-7">
											{formState.galleryImages.map((img: any, idx: number) => (
												<div
													key={`factory-image-supplier-add-form-${idx}`}
													className="col-auto gallery-image-item">
													<div
														className="rounded bg-kumopack-base-white border mb-5 text-center shadow position-relative"
														style={{
															height: isMobileDevice() ? '90px' : '120px',
															width: isMobileDevice() ? '90px' : '120px',
														}}>
														<img
															className="mx-auto w-100 h-100 rounded"
															src={img.path}
															onError={(e: any) => {
																e.target.onerror = null
																e.target.src = '/media/icons/kumopack/default-placeholder.png'
															}}
															style={{ objectFit: 'contain' }}
															alt="Product Images"
															onClick={() => {
																onOpenLightBoxGallery(idx)
															}}
														/>
														<div
															className="btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute"
															style={{ top: -10, right: -10 }}
															onClick={() => onRemoveGalleryImage(img.id)}>
															<KTSVG
																className="svg-icon-1"
																path="/media/icons/duotune/general/gen027.svg"
															/>
														</div>

														<button
															className="view-button"
															onClick={() => {
																onOpenLightBoxGallery(idx)
															}}>
															<img src="/media/icons/kumopack/zoom-in.svg" alt="View Button Icon" />
														</button>
													</div>
												</div>
											))}
										</div>
									) : (
										<div className="fw-bold fs-5 text-kumopack-grey-300 py-10 text-center">
											No Files Uploaded
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-12 text-end">
					<button
						disabled={isSubmitting}
						onClick={onSubmit}
						className={clsx(
							'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
							{
								'w-200px': !isMobileDevice(),
								'w-sm-100': isMobileDevice(),
							}
						)}>
						บันทึก
					</button>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode; companyName: string }> = ({
	children,
	companyName,
}) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Factory Images',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{companyName}
			</PageTitle>

			{children}
		</>
	)
}

export default ImagesView
